module.exports = __webpack_public_path__ + "img/bank.7b3577c5.png";